module.exports = __webpack_public_path__ + "img/package.04626b7b.png";